import { render, staticRenderFns } from "./ShareLayout.vue?vue&type=template&id=3d8f1c93&"
import script from "./ShareLayout.vue?vue&type=script&lang=js&"
export * from "./ShareLayout.vue?vue&type=script&lang=js&"
import style0 from "./ShareLayout.vue?vue&type=style&index=0&id=3d8f1c93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports